<div class="modal-backdrop" (click)="closeModal($event)"></div>
<div class="modal" scroll="no">
  <div class="rouletteWheelDialog">
    <div class=" spinner">
      <div class="spinnerWrapper">
        <div class="spinnerCloseButtonWrapper">
          <button class="closeBtn spinnerCloseButton" (click)="closeModal($event)" data-qa="close"></button>
        </div>
        <div class="spinnerWheel">
          <div>
            <div class="spinnerWheelProportionsHolder"></div>
            <div class="spinnerWheelMotor" [ngClass]="spinningState">
              <div class="spinnerWheelMotorInner">
                <div class="spinnerWheelOptions">
                  <div *ngFor="let option of wheelOptions; let i = index" class="spinnerWheelOption"
                    [ngStyle]="{'transform': 'rotate(-' + ( ((360 / wheelOptions.length) * i) + ((360 / wheelOptions.length) / 2) ) + 'deg) translate( 0px, -50%)'}">
                    {{ option.label }}
                  </div>
                </div>
              </div>
            </div>
            <div class="spinnerWheelPointer" [ngClass]="spinningState">
              <div class="pointer-shadow"></div>
              <div class="pointer"></div>
            </div>
            <div class="spinnerWheelCenterImage">
              <img src="{{ wheelCenterImage }}" alt="{{ title }}">
            </div>
          </div>
        </div>
        <div class="spinnerDescription">
          <div class="spinnerInformation">
            <div class="spinnerDescriptionTitle" [innerHTML]="title"
              [ngClass]="{'display': spinningState !== 'spinned'}">
            </div>
            <div class="spinnerDescriptionTitle" [innerHTML]="spinnedTitle"
              [ngClass]="{'display': spinningState === 'spinned'}"></div>

            <div class="spinnerDescriptionText" [innerHTML]="description"
              [ngClass]="{'display': spinningState !== 'spinned'}"></div>
            <div class="spinnerDescriptionText" [innerHTML]="spinnedDescription"
              [ngClass]="{'display': spinningState === 'spinned'}"></div>
            <div class="spinnerDescriptionSpinButtonWrapper" [ngClass]="{'display': spinningState !== 'spinned'}">
              <button class="spinnerDescriptionSpinButton" (click)="spinTheWHeel()" [innerHTML]="spinButtonText"
                [disabled]="spinningState !== 'not-spinning'"></button>
            </div>
            <div class="spinnerDescriptionSpinnedButtonWrapper" [ngClass]="{'display': spinningState === 'spinned'}">
              <button class="spinnerDescriptionSpinButton" (click)="closeModal($event)"
                [innerHTML]="spinnedButtonText"></button>
            </div>
            <div class="spinnerDescriptionDeclineButtonWrapper" [ngClass]="{'display': spinningState !== 'spinned'}">
              <button class="spinnerDescriptionDeclineButton" (click)="closeModal($event)" [innerHTML]="declineButtonText"
                [disabled]="spinningState !== 'not-spinning'"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>